import { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

// ------------------ COMPONENTES DE BASE--------------------------

// ------------------ CONSULTAS A LA API--------------------------
import { getActivosFijosSimples } from "../../../../../API/Global/ActivosFijos/ActivosFijosRequest";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";

const OverlayActivos = ({ close, rowData, onChange }) => {
  const op = useRef(null);
  const buttom = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [activos, setActivos] = useState([]);

  const fetchData = async () => {
    try {
      const response = await getActivosFijosSimples();
      setActivos(response);
    } catch (error) {
      console.error("Error al llamar a la API:", error);
    }
  };

  const columns = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdActivo",
      frozen: true,
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "Tipo",
      headerEn: "Type",
      field: "Type",
      className: "Xsmall",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      className: "Xsmall",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      header: "Código",
      headerEn: "Code",
      field: "CodigoActivo",
      className: "Xsmall",
    },
    {
      header: "Nombre",
      headerEn: "Name",
      field: "NombreActivo",
    },
    {
      header: "Marca",
      headerEn: "Marca",
      field: "Marca",
    },
    {
      header: "Modelo",
      headerEn: "Modelo",
      field: "Modelo",
    },
    {
      header: "Año",
      headerEn: "Year",
      field: "Ano",
      className: 'Xsmall'
    },
    {
      header: "Serie",
      headerEn: "Serie",
      field: "Serie",
    },
    {
      header: "Area",
      className: 'Xsmall',
      headerEn: "Area",
      field: "Area",
    },
  ];

  const table = {
    Data: activos,
    loading: loading,
    Columns: columns,
    onCellClicked: (e) => onChange(e, rowData),
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div style={{ maxWidth: "50vw" }}>
      <div className="p-inputgroup">
        <InputText
          value={rowData.CodigoActivo}
          disabled
          placeholder="Activo"
          onClick={(e) => op.current.toggle(e)}
        />
        <Button
          ref={buttom}
          icon="pi pi-chevron-down"
          style={{ padding: "0.5rem 0.3rem" }}
          type="button"
          onClick={(e) => op.current.toggle(e)}
        />
      </div>

      <OverlayPanel
        ref={op}
        showCloseIcon
        dismissable={false}
        className="OverPanelProductos"
        onHide={close}
      >
        <div style={{ width: 1300, height: 300 }}>
          <AgGrid table={table} />
        </div>
      </OverlayPanel>
    </div>
  );
};

export default OverlayActivos;
